import React from "react";
import { Upload, Loader2, FileText as FileIcon, Image as ImageIcon } from "lucide-react";
import { getToken, API } from "@/lib/api";
import { formatDateTime } from "@/lib/utils-app";

/** Dokumentlistan + uppladdningsknappen. */
export default function CaseDocuments({ docs = [], uploading, onUpload, fileRef }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium" style={{ fontFamily: "Outfit" }}>Dokument ({docs.length})</h3>
        <label className="cursor-pointer inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium border border-zinc-300 rounded-sm hover:bg-zinc-100">
          {uploading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
          <input type="file" ref={fileRef} accept=".pdf,.jpg,.jpeg,.png" onChange={onUpload}
            className="hidden" data-testid="case-upload" />
          Ladda upp
        </label>
      </div>
      {docs.length === 0 ? (
        <p className="text-sm text-zinc-500 py-6 text-center">Inga dokument uppladdade ännu.</p>
      ) : (
        <ul className="divide-y divide-zinc-100">
          {docs.map((d) => {
            const isImg = d.content_type?.startsWith("image/");
            const Icon = isImg ? ImageIcon : FileIcon;
            return (
              <li key={d.doc_id} className="py-3 flex items-center gap-3" data-testid={`doc-${d.doc_id}`}>
                <div className="w-10 h-10 bg-blue-50 text-blue-700 flex items-center justify-center rounded-sm flex-shrink-0">
                  <Icon className="w-4 h-4 stroke-[1.5]" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-zinc-900 truncate">{d.filename}</div>
                  <div className="text-xs text-zinc-500">{formatDateTime(d.uploaded_at)} · {d.uploaded_by_name}</div>
                </div>
                <a
                  href={`${API}/crm/documents/${d.doc_id}/download?auth=${getToken()}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs text-blue-700 hover:underline px-2 py-1"
                >
                  Visa
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
